import { notEqualTo } from 'ngrx-forms/validation';
import { BuildValidatorWithComparandDecorator } from './helpers';

export const NotEqualTo = BuildValidatorWithComparandDecorator(notEqualTo, 'DX.FORMS.VALIDATION.ERRORS.NOT_EQUAL_TO');
